import { render } from "./junior.vue?vue&type=template&id=24773fb6&scoped=true"
import script from "./junior.vue?vue&type=script&lang=js"
export * from "./junior.vue?vue&type=script&lang=js"

import "./junior.vue?vue&type=style&index=0&id=24773fb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24773fb6"]])

export default __exports__